// extracted by mini-css-extract-plugin
export default {"container":"NavbarPlain_container__B30xH","clickable":"NavbarPlain_clickable__ZzkST"};